import { render, staticRenderFns } from "./BtnModal.vue?vue&type=template&id=332f3456&"
import script from "./BtnModal.vue?vue&type=script&lang=js&"
export * from "./BtnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports